import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const EducationExpensesStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
